import './scripts/game.js'; 
//import Phaser from 'Phaser';
//import BGimg from './image/background.png';
import './Lifenum.css';
console.log("Hello");
//alert("this is webpack test!!!");
const btn= document.getElementById('btn');
const testDiv= document.getElementById('testDiv');
btn.addEventListener('click', function(){
  const a = parseInt(testDiv.innerText,10);//轉換成數字10進制
  testDiv.innerText= a+1;

})

//class test{
  //#a=1
//}
//const tt=new test();
//todo del
//console.log('tt.a',tt.a);



//function callmetest()
//{
	//'use strict';
	//alert("I am call test.js");
//}


//const DEFAULT_WIDTH = 800;
//const DEFAULT_HEIGHT = 600;

//export const config = {
  //type: Phaser.AUTO,
  //width: 800,
  //height: 600,
  //backgroundColor: '#076b05',
  //parent: 'gameDiv',
 // scale: {
 //   mode: Phaser.Scale.FIT,
 //   autoCenter: Phaser.Scale.CENTER_BOTH,
 //   width: DEFAULT_WIDTH,
 //   height: DEFAULT_HEIGHT
//  },
  //scene: [PreloadScene],
  //scene:
    //{preload: preload,
    //create: create},
  //physics: {
    //這是物理引擎
    //default: 'arcade',
    //預設的引擎模式，夠大部分物理動作適用
   // arcade: {
      //debug: false,
     // gravity: { y: 300 }
   // }
  //}
//}

//function preload(){
 //this.load.image('bg', require('./image/background.png').default);目前會出錯
 //this.load.image('bg', require('./image/background.png'));
 //this.load.image('bg', BGimg);
  //this.load.image('bg', './background.png');
//}

//function create()
//{
  //this.add.image(400, 300, 'bg');
//}

//function update()
//{

//}

//const game = new Phaser.Game(config);